import { NpDiscountPill } from "src/components/np-design/components/NpDiscountPill"
import { NpIcon, NpIconName } from "src/components/np-design/components/NpIcon"
import { CouponData } from "src/data/product-details/types"
import { formatPriceShort } from "src/utilities/price"

export type ProductDiscountPillProps = {
  discount: number
  coupon: CouponData | undefined
  regularPrice: number | undefined
}

export const ProductDiscountPill = ({ discount, coupon, regularPrice }: ProductDiscountPillProps) => {
  const type = coupon ? "coupon" : "sale"
  const iconName: NpIconName = coupon ? "percent" : "sell"
  const heading = coupon ? "Aktion" : "Reduziert"
  const amount = coupon ? coupon.text : formatPriceShort(discount)

  return (
    <NpDiscountPill>
      <NpIcon name={iconName} className="-my-3 size-6" />
      <span className="whitespace-nowrap">
        {heading}: Spare heute {type === "coupon" && regularPrice ? <i>zusätzlich</i> : null} {amount}
      </span>
    </NpDiscountPill>
  )
}
